export default __webpack_public_path__ + "static/media/MP5_1.5409b8bf.png";